import { useMemo } from 'react';
import type { ReactElement } from 'react';
import type { UseAlgoliaFilterReturn } from '../../../../hooks/useAlgoliaFilter';
import { FacetNames } from '../../../../types/algolia';
import { getAlgoliaFacetName } from '../../../../utils/getAlgoliaFacetName';
import { RefinementFacet } from '../RefinementFacet/RefinementFacet';
import { FacetsContainer } from './DisplayFacets.styles';

const initialArrangementOfFacets: string[] = Object.values(FacetNames).map((value) => value);

export function DisplayFacets({
  algoliaFilter,
  facetSequence = [],
  productCount,
}: {
  algoliaFilter: UseAlgoliaFilterReturn;
  facetSequence?: string[];
  productCount: number;
}): ReactElement {
  const arrangeFilterFacets = useMemo(() => {
    const facetNames: string[] = facetSequence.map((facet) => getAlgoliaFacetName(facet)).filter((facet) => facet);
    const newArrangementOfFacets = Array.from(new Set(facetNames.concat(initialArrangementOfFacets)));
    return newArrangementOfFacets;
  }, [facetSequence]);

  return (
    <FacetsContainer>
      {arrangeFilterFacets.map((filterFacet) => (
        <div key={filterFacet}>
          <RefinementFacet productCount={productCount} facet={filterFacet} algoliaFilter={algoliaFilter} />
        </div>
      ))}
    </FacetsContainer>
  );
}
